import _css from "@emotion/css";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { Component } from 'react';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
var gridSize = gridSizeFn();

var Wordmark =
/*#__PURE__*/
function (_Component) {
  _inherits(Wordmark, _Component);

  function Wordmark() {
    _classCallCheck(this, Wordmark);

    return _possibleConstructorReturn(this, _getPrototypeOf(Wordmark).apply(this, arguments));
  }

  _createClass(Wordmark, [{
    key: "render",
    value: function render() {
      var WordmarkLogo = this.props.wordmark;
      return ___EmotionJSX("div", {
        css:
        /*#__PURE__*/
        _css({
          lineHeight: 0,
          // -2px here to account for the extra space at the top of a MenuSection
          // for the scroll hint.
          paddingBottom: gridSize * 3.5 - 2,
          paddingLeft: gridSize * 2,
          paddingTop: gridSize
        }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByZXNlbnRhdGlvbmFsL1dvcmRtYXJrL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVRIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByZXNlbnRhdGlvbmFsL1dvcmRtYXJrL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGdyaWRTaXplIGFzIGdyaWRTaXplRm4gfSBmcm9tICdAYXRsYXNraXQvdGhlbWUvY29uc3RhbnRzJztcblxuY29uc3QgZ3JpZFNpemUgPSBncmlkU2l6ZUZuKCk7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFdvcmRtYXJrIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgd29yZG1hcms6IFdvcmRtYXJrTG9nbyB9ID0gdGhpcy5wcm9wcztcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdlxuICAgICAgICBjc3M9e3tcbiAgICAgICAgICBsaW5lSGVpZ2h0OiAwLFxuICAgICAgICAgIC8vIC0ycHggaGVyZSB0byBhY2NvdW50IGZvciB0aGUgZXh0cmEgc3BhY2UgYXQgdGhlIHRvcCBvZiBhIE1lbnVTZWN0aW9uXG4gICAgICAgICAgLy8gZm9yIHRoZSBzY3JvbGwgaGludC5cbiAgICAgICAgICBwYWRkaW5nQm90dG9tOiBncmlkU2l6ZSAqIDMuNSAtIDIsXG4gICAgICAgICAgcGFkZGluZ0xlZnQ6IGdyaWRTaXplICogMixcbiAgICAgICAgICBwYWRkaW5nVG9wOiBncmlkU2l6ZSxcbiAgICAgICAgfX1cbiAgICAgID5cbiAgICAgICAgPFdvcmRtYXJrTG9nbyAvPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
      }, ___EmotionJSX(WordmarkLogo, null));
    }
  }]);

  return Wordmark;
}(Component);

export { Wordmark as default };